export default __webpack_public_path__ + "static/media/mt.efdd09cd.svg";